import moment from "moment";
import {useEffect, useLayoutEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";

//import Redux
import {
  currentUidAction,
  deleteProject,
  getProjectList,
} from "../../features/sliceReducer/projectListReducer";
import {RootState} from "../../features/store";

//import Material-UI
import {createStyles, makeStyles, Theme, withStyles} from "@material-ui/core/styles";

import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";

//import Component
import ErrorControlled from "../../components/ErrorControlled";

import IPUtility from "../../classes/IPUtility";
import ListFilter from "../../components/ListFilter";
import PaginationControlled from "../../components/PaginationControlled";
import {alertsConfirmAction} from "../../features/sliceReducer/interactionReducer";
import {
  getMyProject,
  setServerSavedAction,
  updateContainerAll,
} from "../../features/sliceReducer/myProjectReducer";
import {
  createProjectAction,
  getEditProject,
  modifyProjectAction,
} from "../../features/sliceReducer/projectReducer";
import {updateContainerAllRequest} from "../../models/IPProject";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      minHeight: "69.3vh",
    },

    table: {
      minWidth: 650,
    },
    tableHead: {
      backgroundColor: theme.palette.gray.light,
    },
    buttonCell: {
      display: "flex",
      gap: 30,
      // justifyContent: "space-around",
    },
    linkStyle: {
      color: theme.palette.primary.main,
      "&:hover": {
        color: theme.palette.primary.dark,
        textDecoration: "underLine",
      },
    },
  })
);

const ProjectList = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();

  const [searchWord, setSearchWord] = useState<string>("");
  const [currentPage, setPage] = useState<number>(1);

  const {projectList, loading, error, maxPage, currentUid, switchChecked, filtering, tableHeader} =
    useSelector((state: RootState) => state.projectList);

  const {user} = useSelector((state: RootState) => state.auth);
  const {userToken} = useSelector((state: RootState) => state.auth);
  const {projectEditSwitch} = useSelector((state: RootState) => state.project);
  const thisUser = useSelector((state: RootState) => state.auth.user);

  const {region, year, grade} = filtering;

  useEffect(() => {
    const tempWord = sessionStorage.getItem("projectSearchWord")!;
    dispatch(
      getProjectList({
        userToken,
        isAll: switchChecked,
        year,
        region,
        grade,
        searchWord: tempWord,
      })
    );
  }, [switchChecked, year, region, grade]);

  useLayoutEffect(
    () => () => {
      sessionStorage.setItem("projectSearchWord", "");
    },
    []
  );

  // let idLines = new Array<number>();

  // useEffect(() => {
  //   idLines = projectList?.map(x => x.uid);
  //   console.log(idLines);
  // }, [projectList]);

  function DownloadAll() {
    console.log("downloadAll");
    const lines = projectList?.map((x) => x.uid).join("|");
    console.log(lines);
    window.open("/Document/GenerateSummary?ids=" + lines);
  }

  function DownloadCount() {
    console.log("downloadCount " + year);
    window.open("/Document/GenerateCount?year=" + year);
  }

  const localData = IPUtility.getLocalProjectInfo();
  useEffect(() => {
    if (userToken && !localData?.isSaveSuccessed && localData?.name != "") {
      const info =
        localData.date +
        "에 서버에 저장하지 못한 '" +
        localData.name +
        "'이 있습니다. 서버에 저장하고 다시 불러오겠습니까?";
      if (window.confirm(info)) {
        // IPUtility.clearLocalProject();
        const param: updateContainerAllRequest = {
          userToken: userToken,
          projectUID: localData.project.uid,
          items: localData.project.categories,
          points: localData.project.manualPointsList,
          noContentItemUIDs: localData.project.noContentItemUIDs,
          successHandler: () => {
            dispatch(
              getMyProject({
                userToken,
                id: localData.project.uid,
                successHandler: () => dispatch(setServerSavedAction(0)),
              })
            );
            navigate("/inspect/myProject/" + localData.project.uid);
          },
          failHandler: () => {
            alert("서버에 저장하지 못했습니다. 인터넷 연결을 확인하시고 다시 시도 하세요");
          },
        };
        dispatch(updateContainerAll(param));
        // dispatch(replaceMyProjectAction(localData.project));
        // navigate("/inspect/editProject");
      }
    }
  }, []);

  const searchDispatcher = (page?: number, keyword?: string) => {
    if (page === undefined) page = 1;
    if (!keyword) {
      if (keyword !== "") keyword = sessionStorage.getItem("projectSearchWord")!;
    }
    // console.log("keyword", keyword);
    if (keyword === undefined)
      dispatch(
        getProjectList({
          userToken,
          isAll: switchChecked,
          searchWord: keyword,
          page,
          year,
          region,
          grade,
        })
      );
    else
      dispatch(
        getProjectList({
          userToken,
          isAll: switchChecked,
          searchWord: keyword,
          page,
          year,
          region,
          grade,
        })
      );
  };

  return (
    <>
      {/* <Loading loading={loading} /> */}
      <ErrorControlled error={error} />
      {/* <AlertsDialog /> */}
      <ListFilter
        setSearchWord={setSearchWord}
        searchDispatcher={searchDispatcher}
        page={currentPage}
        searchWord={searchWord}
        subTitle={"Project List"}
        buttonTitle={"프로젝트 추가"}
        modal={createProjectAction}
        endPoint={"manageProject"}
        changeHandler={() => {
          setPage(1);
        }}
      ></ListFilter>
      <Box>
        {/* In Progress TODO */}
        {/* <Typography>{localData.name} : {localData.isSaveSuccessed ? "OK" : "NotSaved"}</Typography>
        <Button
          onClick={() => {
            dispatch(replaceMyProjectAction(localData.project));
            navigate("/inspect/editProject");
          }}
        >Action</Button> */}
      </Box>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              {tableHeader.map((headerTitle, index) => (
                <TableCell key={index} align="center">
                  {headerTitle}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {projectList?.map((project, index) => {
              const isCreator = project.projectLeaderUID === thisUser.uid;
              const isParticipant = project.participantsUIDs.indexOf(thisUser.uid) > -1 || user.userLevel == 1 || user.userLevel == 2;
              return (
                <StyledTableRow key={project.uid}>
                  <TableCell component="th" scope="row" align="center">
                    {project.uid}
                  </TableCell>
                  <TableCell align="center">{moment(project.startDate).format("YYYY년")}</TableCell>
                  <TableCell align="left">{project.factoryName}</TableCell>

                  <TableCell
                    align="left"
                    onClick={() => {
                      if (isParticipant) dispatch(currentUidAction(project.uid));
                    }}
                  >
                    {isParticipant ? (
                      <Link className={classes.linkStyle} to={`myProject/${project.uid}`}>
                        <p>{project.name}</p>
                      </Link>
                    ) : (
                      <p>{project.name}</p>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {moment(project.entryDate).format("YYYY년 MM월 DD일")}
                  </TableCell>
                  <TableCell align="center">{project.projectUserName}</TableCell>
                  <TableCell align="center">{project.participantsUsersName}</TableCell>
                  {/* <TableCell align="center">도움말편집</TableCell> */}
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<EditIcon />}
                      disabled={!isCreator}
                      onClick={async () => {
                        await Promise.resolve(
                          dispatch(getEditProject({userToken, id: project.uid}))
                        );
                        dispatch(modifyProjectAction());

                        navigate("manageProject");
                      }}
                    >
                      편집
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    {user.uid === project.projectLeaderUID && (
                      <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<DeleteIcon />}
                        disabled={!isCreator}
                        onClick={() => {
                          dispatch(
                            alertsConfirmAction({
                              alertContent: "해당 프로젝트를 삭제하시겠습니까?",
                              alertAction: deleteProject({
                                userToken,
                                id: project.uid,
                                successHandler: () => {
                                  searchDispatcher(currentPage, searchWord);
                                },
                              }),
                            })
                          );
                        }}
                      >
                        삭제
                      </Button>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        IPUtility.openWord(
                          project.uid,
                          userToken,
                          project.factoryName +
                            " " +
                            moment(project.startDate).format("YYYY년 ") +
                            project.name
                        );
                      }}
                      startIcon={<DescriptionIcon />}
                    >
                      생성
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="secondary"
                      disabled={
                        !isCreator ||
                        project.uploadedFileName === undefined ||
                        project.uploadedFileName.length === 0
                      }
                      onClick={() => {
                        window.open(
                          "/uploads/inspect/attachments/" + project.uploadedFileName,
                          "_blank"
                        );
                      }}
                      startIcon={<DescriptionIcon />}
                    >
                      다운로드
                    </Button>
                  </TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {thisUser.userLevel == 1 && (
        <div>
          <Button onClick={DownloadAll}>Download All</Button>
          <Button onClick={DownloadCount}>Download Count</Button>
        </div>
      )}
      <PaginationControlled
        maxPage={maxPage}
        page={currentPage}
        pageChange={(value: number) => searchDispatcher(value, searchWord)}
      />
    </>
  );
};

export default ProjectList;
